import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import { Box, Grid, Typography } from '@mui/material';
import { SectionTitleFontSize } from '../PurchaseTraining';

/**
 * A section to outline the process of onboarding during a training purchase
 */
const Process = () => {
  const steps = [
    {
      title: 'Step 1: Welcome',
      description:
        'Get an overview of the onboarding process and learn what information will be needed.',
    },
    {
      title: 'Step 2: Basic Information',
      description:
        'Provide essential details about your organization to tailor your training and generate the necessary legal documents.',
    },
    {
      title: 'Step 3: License & Pricing',
      description:
        'Select the number of licenses you need and view pricing options—enjoy tiered discounts for bulk orders.',
    },
    {
      title: 'Step 4: Master Service Agreement',
      description:
        'Review a custom-generated Master Service Agreement based on your organization’s details and license selection.',
    },
    {
      title: 'Step 5: Payment',
      description:
        'Securely complete your payment using credit card or ACH, set up as an annual subscription.',
    },
    {
      title: 'Step 6: Organization Setup',
      description:
        'Finalize your setup by configuring organizational details, importing managers, and selecting the required training modules.',
    },
  ];

  return (
    <Box sx={{ py: 10 }}>
      <Typography
        variant="h4"
        component="h2"
        align="center"
        sx={{
          marginBottom: '1em',
          fontWeight: 500,
          fontSize: SectionTitleFontSize,
        }}
      >
        Your 6-Step Onboarding Journey
      </Typography>
      <Grid container spacing={4} justifyContent="center">
        {steps.map((step, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Box sx={{ textAlign: 'center', p: 2 }}>
              <CheckCircleOutlineRoundedIcon
                color="success"
                sx={{ fontSize: 40 }}
              />
              <Typography
                variant="h6"
                component="h3"
                gutterBottom
                sx={{ mt: 2 }}
              >
                {step.title}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {step.description}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Process;
